import { API as e, Resource as t } from "@coveo/platform-client";
//#region src/resources/commerce/CatalogFields.ts
var n = class n extends t {
	static {
		this.baseUrl = `/rest/organizations/${e.orgPlaceholder}/commerce/private/catalog`;
	}
	static {
		this.cmsBaseUrl = `/api/private/organizations/${e.orgPlaceholder}/catalog-management/catalogs/fields`;
	}
	getFieldValues(e) {
		return this.api.post(`${n.baseUrl}/field/values`, e);
	}
	getFieldValuesCMS(e) {
		return this.api.post(`${n.cmsBaseUrl}/values`, e);
	}
};
//#endregion
export { n as CatalogFields };

//# sourceMappingURL=CatalogFields.js.map